import React, { Component } from 'react';

class About extends Component {
   render() {

      if (this.props.data) {
         var name = this.props.data.name;
         var profilepicwebp = "images/" + this.props.data.image + ".webp";
         var profilepicwpng= "images/" + this.props.data.image + ".png";
         
         // var intro = this.props.data.bio.intro;
         // var details = this.props.data.bio.details;
         // var offerings = this.props.data.bio.offerings;
         var town = this.props.data.address.town;
         var region = this.props.data.address.region;
         var country = this.props.data.address.country;
         var postcode = this.props.data.address.postcode;
         var phone = this.props.data.phone;
         var email = this.props.data.email;
      }

      return (
         <section id="about">
            <div className="row">
               <div className="three columns">
                  <picture className="profile-pic">
                  <source  srcSet={profilepicwebp} alt="Allison Profile Pic" type="image/webp" />
                  <source  srcSet={profilepicwpng} alt="Allison Profile Pic" type="image/png" />
                  <img src={profilepicwpng} />
                  </picture>
               </div>
               <div className="nine columns main-col">
                  <h2>About Us</h2>

                  {/* <p>{intro}</p>
                  <p>{details}</p>
                  <p>{offerings}</p> */}
                  <div className="row">
                     <div className="columns contact-details">
                        <h2>Contact Details</h2>
                        <p className="address">
                           <span>{name}</span><br />
                           <span>
                              {town},  <br />
                              {region}, <br />
                              {country} <br />
                              {postcode}
                           </span>
                           <br /><br />
                           <span className="fa fa-mobile-phone"> Mobile: {phone}</span><br />
                           <span className="fa fa-envelope"> Email: {email}</span>
                        </p>
                     </div>
                     <div className="columns download">
                        <h2> Downloads</h2>
                        <p>
                           <a href="#download" className="button"><i className="fa fa-download"></i>Download Some Sort Of Document</a>
                        </p>
                     </div>
                  </div>
               </div>
            </div>

         </section>
      );
   }
}

export default About;
